<template>
  <div class="main-page" ref="aboutPage">
    <div class="first-page more-height">
      <div class="font-area" :class="globalTransition">
        <div class="explain">
          <p>{{$t('aboutPage.p1.title')}}</p></div>
        <div class="p1">
          <p>{{$t('aboutPage.p1.p1')}}</p></div>
        <div class="p2">
          <p>{{$t('aboutPage.p1.p2')}}</p>
          <p>{{$t('aboutPage.p1.p2_1')}}</p>
        </div>
        <div class="p3">
          <p>{{$t('aboutPage.p1.p3')}}<br>
         {{$t('aboutPage.p1.p4')}}</p></div>
      </div>
      <transition name="fade">
        <div v-show="!hideDownBtn"
             class="p5" @mouseenter="rightArrowShow=true"
             @mouseleave="rightArrowShow=false"
             @click="jump2nextPage('aboutDetailPage')"
        >
          <transition name="fade">
            <div class="icon-div" :class="rightArrowShow?'show':''">
              <i class="el-icon-arrow-down"></i></div>
          </transition>
        </div></transition>
    </div>
    <aboutDetail ref="aboutDetailPage"></aboutDetail>
    <aboutBoard ref="aboutBoardPage"></aboutBoard>
   <!-- <aboutCommittee  ref="aboutCommitteePage"></aboutCommittee>-->
    <aboutAward  ref="aboutAwardPage"></aboutAward>
    <footMenu></footMenu>
  </div>
</template>

<script>
import aboutDetail from '@/views/aboutPage/detail';
import aboutBoard from '@/views/aboutPage/board';
import aboutCommittee from '@/views/aboutPage/committee';
import aboutAward from '@/views/aboutPage/award';
import footMenu from '@/components/footMenu';

export default {
  name: 'aboutPage',
  components: {
    aboutDetail,
    aboutBoard,
    aboutCommittee,
    aboutAward,
    footMenu,
  },
  data() {
    return {
      rightArrowShow: false,
      doTransition: true,
      showDiscoveryPage: false,
      hideDownBtn: false,
    };
  },
  mounted() {
    window.addEventListener('scroll', this.handleScroll, true);
    this.author = this.$route.query.anchor;
    if (this.author) { this.jump2nextPage(this.author); }
  },
  computed: {
    language() {
      return this.$store.getters.language;
    },
    globalTransition() {
      return this.$store.getters.globalTransition ? 'global-i18n-hide' : 'global-i18n-not-hide';
    },
    anchor() {
      return this.$route.query.anchor;
    },
  },
  watch: {
    globalTransition() {
      this.doTransition = !this.doTransition;
    },
    anchor() {
      this.jump2nextPage(this.anchor);
    },
  },
  methods: {
    showDiscoveryBtnClick() {
      this.showDiscoveryPage = true;
      this.rightArrowShow = false;
    },
    handleScroll() {
      // eslint-disable-next-line
      this.hideDownBtn = this.$refs.aboutPage.scrollTop >= 80;
    },
    jump2nextPage(ref) {
      const that = this;
      let distance = this.$refs.aboutPage.scrollTop;
      const total = this.$refs[ref].$el.offsetTop - 100;
      let step = total / 50;
      if (total > distance) {
        // eslint-disable-next-line
          scrollDown();
      } else {
        const newTotal = distance - total;
        step = newTotal / 50;
        // eslint-disable-next-line
          scrollUp();
      }


      function scrollDown() {
        if (distance < total) {
          distance += step;
          that.$refs.aboutPage.scrollTop = distance;
          window.pageYOffset = total;
          setTimeout(scrollDown, 8);
        } else {
          that.$refs.aboutPage.scrollTop = total;
          window.pageYOffset = total;
        }
      }
      function scrollUp() {
        if (distance > total) {
          distance -= step;
          that.$refs.aboutPage.scrollTop = distance;
          window.pageYOffset = total;
          setTimeout(scrollUp, 10);
        } else {
          that.$refs.aboutPage.scrollTop = total;
          window.pageYOffset = total;
        }
      }
    },
  },
};
</script>

<style lang="scss" scoped>
  .main-page{
    background-image:url("../../assets/aboutBg1.jpg");
  }
  .discovery-page{
    height: 100%;
    width: 100%;
  }
  .more-height{
    min-height: 600px;
  }
.font-area{
  max-width: 45%;
  .p2{
    white-space: nowrap;
  }
  .p3{
    white-space: nowrap;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/aboutPage/index.vue